import { money } from "@/lib/api";

export const ProgressBar = ({ value, label, hint, testid, tone = "sky" }) => {
  const pct = Math.max(0, Math.min(100, Number(value || 0)));
  const bar = { sky: "bg-crimson-500", emerald: "bg-emerald-500", amber: "bg-amber-500" }[tone];
  return (
    <div data-testid={testid}>
      <div className="flex items-end justify-between">
        <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
        <span className="font-display text-sm font-semibold text-brand-ink">{pct}%</span>
      </div>
      <div className="mt-2 h-2 rounded-full bg-slate-100">
        <div className={`h-2 rounded-full ${bar} transition-all duration-500`} style={{ width: `${pct}%` }} />
      </div>
      {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
    </div>
  );
};

export const TierScore = ({ score, testid }) => {
  const tone =
    score >= 75 ? "text-emerald-600" : score >= 50 ? "text-amber-600" : "text-rose-600";
  return (
    <span data-testid={testid} className={`font-display text-lg font-semibold ${tone}`}>
      {Number(score || 0).toFixed(1)}
    </span>
  );
};

export const TargetSummary = ({ card }) => (
  <div className="grid gap-6 sm:grid-cols-2">
    <ProgressBar
      testid="target-revenue-progress"
      label="Revenue vs target"
      tone="emerald"
      value={card?.revenue_progress_pct}
      hint={`${money(card?.month_revenue)} of ${money(card?.revenue_target)} this month`}
    />
    <ProgressBar
      testid="target-units-progress"
      label="Service targets achieved"
      value={card?.target_achievement_pct}
      hint={`${card?.actual_units ?? 0} of ${card?.target_units ?? 0} units across ${
        card?.services_with_target ?? 0
      } service types`}
    />
  </div>
);
